import * as actionTypes from '../action/actionTypes';
import { updateObject } from '../../utils';

const initialState = {
  count: 0,
  notifications: [],
  openVersionUpdateModal: false,
  skippedVersion: null
};

const fetchNotifications = (state, action) => {
  return updateObject(state, {
    count: action.data && action.data.notification_count,
    notifications: action.data && action.data.notifications
  });
};

const openVersionUpdateModal = (state, action) => {
  return updateObject(state, {
    openVersionUpdateModal: true
  });
};

const closeVersionUpdateModal = (state, action) => {
  return updateObject(state, {
    openVersionUpdateModal: false
  });
};

const skippedVersion = (state, action) => {
  return updateObject(state, {
    skippedVersion: action.data && action.data.skippedVersion
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NOTIFICATIONS:
      return fetchNotifications(state, action);
    case actionTypes.OPEN_VERSION_UPDATE_MODAL:
      return openVersionUpdateModal(state, action);
    case actionTypes.CLOSE_VERSION_UPDATE_MODAL:
      return closeVersionUpdateModal(state, action);
    case actionTypes.SKIPPED_VERSION:
      return skippedVersion(state, action);
    default:
      return state;
  }
};
export default reducer;
